module.exports = __webpack_public_path__ + "img/view_agenda.21068bd0.svg";